import { defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
import _imports_0 from '@/assets/dashboard/welcome.png';
const _withScopeId = n => (_pushScopeId("data-v-b541f38e"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "dashboard-page common-page flex-center"
};
const _hoisted_2 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: ""
}, null, -1));
const _hoisted_3 = [_hoisted_2];
import { useRoute, useRouter } from 'vue-router';
export default /*#__PURE__*/_defineComponent({
  __name: 'dashboard',
  setup(__props) {
    const route = useRoute();
    const router = useRouter();
    return (_ctx, _cache) => {
      return _openBlock(), _createElementBlock("div", _hoisted_1, _hoisted_3);
    };
  }
});